import { render, staticRenderFns } from "./distributorDetail.vue?vue&type=template&id=f7a04e5e&scoped=true&"
import script from "./distributorDetail.vue?vue&type=script&lang=ts&"
export * from "./distributorDetail.vue?vue&type=script&lang=ts&"
import style0 from "./distributorDetail.vue?vue&type=style&index=0&id=f7a04e5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a04e5e",
  null
  
)

export default component.exports